<template>
  <div>
    <!-- 关联标签 -->
    <!-- <el-form-item label="从哪入库">
      <el-input v-model="form.supply.name" style="width: 200px;" class="max-w460"></el-input>
      <el-button type="primary"  style="margin-left: 10px;" @click="changeProduct()">选择从哪入库</el-button>
      <el-button style="margin-left: 10px;"   @click="deleteClick()">清除</el-button>
    </el-form-item> -->
    
    <!--标签选择-->
    <Supply :isproduct="isproduct" @closeDialog="closeDialogFunc"></Supply>


    <el-form-item label="入库到哪" v-if="isuse == 1">
      <el-input v-model="form.tsupply.name" style="width: 200px;" class="max-w460"></el-input>
      <el-button type="primary"  style="margin-left: 10px;" @click="changeProduct1()">选择入库到哪</el-button>
      <el-button style="margin-left: 10px;"   @click="deleteClick1()">清除</el-button>
    </el-form-item>
    
    <!--标签选择-->
    <Supply1 :isproduct="isproduct1" @closeDialog="closeDialogFunc1"></Supply1>

  </div>
</template>

<script>
import Supply from '@/components/supply/Supply';
import Supply1 from '@/components/supply/Supply';
import {mergeTable} from '@/utils/table.js';

export default {
  components: {
    /*选择商品组件*/
    Supply,
    Supply1
  },
  data() {
    return {
      unit: '%',
      isproduct: false,
      isproduct1: false,
      isuse:0
    };
  },
  props: {
    form: Object
  },
  created() {
    console.log(11111)
    var self = this;
    this.getInas({},function(res){
      console.log(res)
      self.isuse = res
    })
 
  },
  methods: {
    /*关闭弹窗*/
    /*关闭弹窗*/
    closeDialogFunc(e) {
      console.log(e)
      let self = this;
      self.isproduct = false;
      if (e.type == 'success') {
        var supply = {
          name:e.params[0].name,
          supply_id:e.params[0].supply_id,
        }
        self.form.supply = supply
        self.form.supply_id = supply.supply_id
      }
    },
    /*打开添加*/
    changeProduct() {
      
      this.isproduct = true;
    },
    /*删除标签*/
    deleteClick() {
      let self = this;
       self.form.supply = ''
        self.form.supply_id = 0
    },

    closeDialogFunc1(e) {
      console.log(e)
      let self = this;
      self.isproduct1 = false;
      if (e.type == 'success') {
        var supply = {
          name:e.params[0].name,
          t_supply_id:e.params[0].supply_id,
        }
        self.form.tsupply = supply
        self.form.t_supply_id = supply.t_supply_id
      }
    },
    /*打开添加*/
    changeProduct1() {
      
      this.isproduct1 = true;
    },
    /*删除标签*/
    deleteClick1() {
      let self = this;
       self.form.tsupply = ''
        self.form.t_supply_id = 0
    },
  }
};
</script>

<style>
.el-tag + .el-tag {
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/supply/supply_commons.vue